import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import api from "../../api/api";
import { FiPlusCircle, FiX } from "react-icons/fi";
import {
  FaCheck,
  FaClipboardCheck,
  FaGlobe,
  FaRegClock,
  FaShoppingCart,
  FaWhatsapp,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useProfileStore } from "../../store/useUserStore";
import { format12HourTime, formatDay } from "../../helpers/helper";
import { Pagination } from "swiper/modules";
import BundleCard from "../../components/Bundle/BundleCard";
import { IoBookmarks } from "react-icons/io5";

type Props = {};

interface Month {
  id: string;
  name: string;
  date: Date;
  disabled?: boolean;
}

const CourseView = (props: Props) => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [course, setCourse] = useState<any>({
    images: [],
    name: "",
    description: "",
    course_type: 1,
    price: 0,
    branches: [],
    puchased_date: [],
  });
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const from = queryParams.get("from");
  const [cartOptionOpen, setCartOptionOpen] = useState(false);
  const [cartItemOptionOpen, setCartItemOptionOpen] = useState(false);
  const {
    students,
    selectedStudent,
    homePageShow,
    startProgress,
    tickProgress,
    setLastVisitedCourseId,
    fetchStudentsRefresh,
    hasStudentWithSchoolId,
  } = useProfileStore();
  const [innerSelectedStudent, setInnerSelectedStudent] = useState<any[]>([]);

  const [selectedPricingPackage, setSelectedPricingPackage] =
    useState<any>(null);
  const [selectedClassroom, setSelectedClassroom] = useState<string | null>(
    null,
  );
  const [selectedDay, setSelectedDay] = useState<string | null>(null);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);

  const [bundleCartOptionOpen, setBundleCartOptionOpen] = useState(false);
  const [bundleCourseDetail, setBundleCourseDetail] = useState<any>(null);
  const [selectedBundlePricingPackage, setSelectedBundlePricingPackage] =
    useState<any>(null);
  const [selectedBundleClassroom, setSelectedBundleClassroom] = useState<
    string | null
  >(null);
  const [selectedBundleDay, setSelectedBundleDay] = useState<string | null>(
    null,
  );

  useEffect(() => {
    if (!selectedStudent || Object.keys(selectedStudent).length == 0) {
      getCourseByAcademy();
    } else {
      getCourseBySchool();
    }
    // if (id && !from) {
    //     setLastVisitedCourseId(id)
    // }
  }, []);

  // when lastVistitedCourseId is change in footer, then it should refresh when coming back to courseView page
  // useEffect(() => {
  //     if (lastVisitedCourseId !== null) {
  //         window.location.reload()
  //     }
  // }, [lastVisitedCourseId])

  function getCourseBySchool() {
    startProgress(1);
    api
      .get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/course/branch/${id}?student_id=${selectedStudent?.id}&start_from=${getSixMonthsBefore()}`,
      )
      .then((res) => {
        // console.log("res courseview", res.data.data)
        setCourse(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        tickProgress();
      });
  }

  function getCourseByAcademy() {
    startProgress(1);
    api
      .get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/course/branch/${id}?start_from=${getSixMonthsBefore()}`,
      )
      .then((res) => {
        // console.log("res courseview", res.data.data)
        setCourse(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        tickProgress();
      });
  }

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedMonths, setSelectedMonths] = useState<Month[]>([]);
  const [selectedBundleMonths, setSelectedBundleMonths] = useState<Month[]>([]);

  function handleAddToCart() {
    if (!selectedClassroom || !selectedDay) {
      return toast.warn(t("course_view.please_select_classroom_day_timeslot"));
    }

    let studentIds: number[] = [];
    if (homePageShow === "academy") {
      // from academy
      if (!innerSelectedStudent || innerSelectedStudent.length === 0)
        return toast.warn(t("course_view.please_select_student"));
      studentIds = innerSelectedStudent.map((student) => student.id);
    } else {
      // from school
      if (!selectedStudent || Object.keys(selectedStudent).length == 0)
        return toast.warn(t("course_view.please_select_student"));
      studentIds = [selectedStudent.id];
    }

    // Payment Term validation
    if (
      !selectedPricingPackage ||
      selectedMonths.length % selectedPricingPackage.count !== 0
    ) {
      return toast.warn(t("course_view.please_select_valid_payment_month"));
    }

    // Check if selectedMonths length is a valid multiple of course.period
    if (course.pricing_method && course.pricing_method.name === "Month") {
      if (selectedMonths.length === 0)
        return toast.warn(t("course_view.please_select_period"));
    }

    console.log("selectedMonth", selectedMonths);
    console.log("selectedMonth", JSON.stringify(selectedMonths));
    // Convert selectedMonths into the desired format
    const formattedMonths = selectedMonths.map((month: Month) => {
      console.log("month", JSON.stringify(month));
      const [monthName, year] = month.name.split(" ");
      console.log("month 2 ", JSON.stringify(year), JSON.stringify(monthName));

      const date = new Date(`${monthName} 1, ${year}`);
      console.log("date", JSON.stringify(date));
      console.log(
        "date 2",
        date.toLocaleDateString("en-US", { month: "2-digit", year: "numeric" }),
      );
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
      });
    });

    // Get the selected classroom
    const classroom = course.time_slots.find(
      (slot: any) => slot.course_slot_id === parseInt(selectedClassroom!),
    );
    if (!classroom)
      return toast.warn(t("course_view.please_select_classroom_day_timeslot"));

    const timeSlotId = course.time_slots
      .flatMap((slot) => slot.schedules)
      .find((schedule) => schedule.course_schedule_id == selectedDay)
      ?.class_timeslots[0]?.time_slot_id;

    let payload: any = {
      student_ids: studentIds,
      type: "course",
      id: id,
      course_branch_id: id,
      payment_term_id: selectedPricingPackage.id,
      time_slot_id: timeSlotId,
      course_slot_id: selectedClassroom,
      course_schedule_id: selectedDay,
    };

    // pricing_method == Month only have selected Month to choose
    if (course.pricing_method && course.pricing_method.name === "Month") {
      payload["selected_date"] = formattedMonths;
    }

    console.log("payload", JSON.stringify(payload));
    console.log("payload", payload);

    startProgress(1);
    api
      .post(`${process.env.PUBLIC_URL}/cart/add`, payload)
      .then((res) => {
        toast.success(t("course_view.added_to_cart"));
        console.log("res", res);
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.errors &&
          err.response.data.errors.message.length > 0
        ) {
          for (let msg in err.response.data.errors.message) {
            toast.error(err.response.data.errors.message[msg]);
          }
        } else {
          toast.error(t("server_error"));
        }
      })
      .finally(() => {
        tickProgress();
        setCartOptionOpen(false);
      });
  }

  function handlePreEnroll() {
    if (!selectedClassroom || !selectedDay) {
      return toast.warn(t("course_view.please_select_classroom_day_timeslot"));
    }

    let studentIds: number[] = [];
    if (homePageShow === "academy") {
      // from academy
      if (!innerSelectedStudent || innerSelectedStudent.length === 0)
        return toast.warn(t("course_view.please_select_student"));
      studentIds = innerSelectedStudent.map((student) => student.id);
    } else {
      // from school
      if (!selectedStudent || Object.keys(selectedStudent).length == 0)
        return toast.warn(t("course_view.please_select_student"));
      studentIds = [selectedStudent.id];
    }

    // Payment Term validation
    if (
      !selectedPricingPackage ||
      selectedMonths.length % selectedPricingPackage.count !== 0
    ) {
      return toast.warn(t("course_view.please_select_valid_payment_month"));
    }

    // Check if selectedMonths length is a valid multiple of course.period
    if (course.pricing_method && course.pricing_method.name === "Month") {
      if (selectedMonths.length === 0)
        return toast.warn(t("course_view.please_select_period"));
    }

    console.log("selectedMonth", selectedMonths);
    console.log("selectedMonth", JSON.stringify(selectedMonths));
    // Convert selectedMonths into the desired format
    const formattedMonths = selectedMonths.map((month: Month) => {
      console.log("month", JSON.stringify(month));
      const [monthName, year] = month.name.split(" ");
      console.log("month 2 ", JSON.stringify(year), JSON.stringify(monthName));

      const date = new Date(`${monthName} 1, ${year}`);
      console.log("date", JSON.stringify(date));
      console.log(
        "date 2",
        date.toLocaleDateString("en-US", { month: "2-digit", year: "numeric" }),
      );
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
      });
    });

    // Get the selected classroom
    const classroom = course.time_slots.find(
      (slot: any) => slot.course_slot_id === parseInt(selectedClassroom!),
    );
    if (!classroom)
      return toast.warn(t("course_view.please_select_classroom_day_timeslot"));

    const timeSlotId = course.time_slots
      .flatMap((slot) => slot.schedules)
      .find((schedule) => schedule.course_schedule_id == selectedDay)
      ?.class_timeslots[0]?.time_slot_id;

    let payload: any = {
      student_ids: studentIds,
      type: "course",
      id: id,
      course_branch_id: id,
      payment_term_id: selectedPricingPackage.id,
      time_slot_id: timeSlotId,
      course_slot_id: selectedClassroom,
      course_schedule_id: selectedDay,
    };

    // pricing_method == Month only have selected Month to choose
    if (course.pricing_method && course.pricing_method.name === "Month") {
      payload["selected_date"] = formattedMonths;
    }

    console.log("payload", JSON.stringify(payload));
    console.log("payload", payload);

    startProgress(1);
    api
      .post(`${process.env.PUBLIC_URL}/preenroll/add`, payload)
      .then((res) => {
        toast.success(t("course_view.pre_enroll_success"));
        console.log("res", res);
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.errors &&
          err.response.data.errors.message.length > 0
        ) {
          for (let msg in err.response.data.errors.message) {
            toast.error(err.response.data.errors.message[msg]);
          }
        } else {
          toast.error(t("server_error"));
        }
      })
      .finally(() => {
        tickProgress();
        setCartOptionOpen(false);
      });
  }

  function handleAddToCartItem(item_id: number) {
    let studentIds: number[] = [];
    if (homePageShow === "academy") {
      // from academy
      if (!innerSelectedStudent || innerSelectedStudent.length === 0)
        return toast.warn(t("course_view.please_select_student"));
      studentIds = innerSelectedStudent.map((student) => student.id);
    } else {
      // from school
      if (!selectedStudent || Object.keys(selectedStudent).length == 0)
        return toast.warn(t("course_view.please_select_student"));
      studentIds = [selectedStudent.id];
    }

    startProgress(1);
    api
      .post(`${process.env.PUBLIC_URL}/cart/add`, {
        student_ids: studentIds,
        type: "item",
        id: item_id,
        quantity: 1,
        course_branch_id: id,
      })
      .then((res) => {
        toast.success(t("course_view.added_to_cart"));
        console.log("res", res);
      })
      .catch((err) => {
        toast.error(t("server_error"));
        console.log("err", err);
      })
      .finally(() => {
        tickProgress();
      });
  }

  useEffect(() => {
    // Attach event listener to close dropdown on outside click
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event: any) => {
    // Close the dropdown if clicked outside
    if (!event.target.closest(".dropdown-container")) {
      setIsOpen(false);
    }
  };

  const toggleDropdown = (): void => {
    setIsOpen(!isOpen);
  };

  const getMonths = (): Month[] => {
    const months: Month[] = [];
    const startDate = new Date();
    startDate.setDate(1); // Start from the first day of the current month
    startDate.setMonth(startDate.getMonth() - 6); // Move 6 months back

    // English month names
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    for (let i = 0; i < 24; i++) {
      // Total 24 months (6 past + current + 17 future)
      const month = new Date(startDate);
      month.setMonth(startDate.getMonth() + i);

      const year = month.getFullYear();
      const monthNumber = String(month.getMonth() + 1).padStart(2, "0");
      const monthIndex = month.getMonth();

      months.push({
        id: `${year}-${monthNumber}`,
        name: `${monthNames[monthIndex]} ${year}`,
        date: month,
        disabled:
          course.purchased_date &&
          course.purchased_date.includes(`${year}-${monthNumber}`)
            ? true
            : false,
      });
    }

    return months;
  };

  const months: Month[] = getMonths();

  const handleSelectMonth = (selectedMonth: Month): void => {
    const isSelected = selectedMonths.some((item) => item.id === selectedMonth.id);
    if (isSelected) {
      setSelectedMonths(selectedMonths.filter((item) => item.id !== selectedMonth.id));
    } else {
      setSelectedMonths([...selectedMonths, selectedMonth]);
    }
  };

  const isChecked = (month: Month): boolean => {
    return selectedMonths.some((m) => m.id === month.id);
  };

  const getSelectedRangeLabel = (): string => {
    if (selectedMonths.length === 0) return "Select a Month";
    // const startMonth = selectedMonths[0].name
    // const endMonth = selectedMonths[selectedMonths.length - 1].name
    // const period = course.period || 1
    // if (period === 1) {
    //     return `${startMonth}`
    // }
    // return `${startMonth} - ${endMonth}`
    const items = selectedMonths;

    items.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    return items.map((s) => s.name).join(", ");
  };

  // For bundle modal: handle month selection
  const handleBundleSelectMonth = (selectedMonth: Month): void => {
    const isSelected = selectedBundleMonths.some((item) => item.id === selectedMonth.id);
    if (isSelected) {
      setSelectedBundleMonths(selectedBundleMonths.filter((item) => item.id !== selectedMonth.id));
    } else {
      setSelectedBundleMonths([...selectedBundleMonths, selectedMonth]);
    }
  };

  const isCheckedBundle = (month: Month): boolean => {
    return selectedBundleMonths.some((m) => m.id === month.id);
  };

  const getSelectedRangeLabelBundle = (): string => {
    if (selectedBundleMonths.length === 0) return "Select a Month";
    const items = selectedBundleMonths;

    items.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    return items.map((s) => s.name).join(", ");
  };

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const getShortenedDescription = (html: any) => {
    if (html == "" || html == null) return "";

    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Replace <p> and <br> with newline characters to count lines
    const textWithLineBreaks = tempElement.innerHTML
      .replace(/<\/p>|<br\s*\/?>/gi, "\n") // Add line breaks
      .replace(/<[^>]+>/g, "") // Remove other HTML tags
      .trim();

    // Split by lines and take only first 8 lines
    const lines = textWithLineBreaks.split("\n");
    const maxLines = 8;

    if (lines.length <= maxLines) {
      // If content has 8 lines or less, return the original HTML
      return parse(html);
    }

    // Take first 8 lines and add ellipsis
    const shortenedLines = lines.slice(0, maxLines);
    const shortenedText = shortenedLines.join("\n") + "...";

    // Replace newlines with <br> before parsing
    return parse(shortenedText.replace(/\n/g, "<br/>"));
  };

  const navigateBack = () => {
    if (from === "cart") {
      navigate("/cart"); // Navigate back to /cart if from=cart
    } else if (from === "bundle") {
      navigate(-1); // Navigate back to previous page
    } else {
      if (hasStudentWithSchoolId) {
        navigate("/school");
      } else {
        setLastVisitedCourseId(null);
        navigate("/", { replace: true }); // Navigate to the home page if no history exists
      }
    }
  };

  function getSixMonthsBefore(): string {
    // For matching with purchased_date / waive course month
    const now = new Date();
    now.setMonth(now.getMonth() - 6);

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month format
    // YYYY-MM
    return `${year}-${month}`;
  }

  const [selectedItemId, setSelectedItemId] = useState<any>(null);
  function openCartItemOption(itemId: number) {
    setCartItemOptionOpen(true);
    setSelectedItemId(itemId);
  }

  function getBasePrice(): string {
    if (course.pricing_packages && course.pricing_packages.length > 0) {
      return "RM " + course.pricing_packages[0].fee;
    }
    return "-";
  }

  function getCalculatedPrice(): string {
    return selectedPricingPackage ? selectedPricingPackage.fee : "-";
  }

  const toggleInnerSelectedStudent = (student: any) => {
    setInnerSelectedStudent((prev) => {
      const exists = prev.find((s) => s.id === student.id);
      if (exists) {
        // Remove student
        return prev.filter((s) => s.id !== student.id);
      } else {
        // Add student
        return [...prev, student];
      }
    });
  };

  const [scheduleOptions, setScheduleOptions] = useState<
    { course_schedule_id: number; label: string }[]
  >([]);

  const handleClassroomChange = (classroomId: string) => {
    setSelectedClassroom(classroomId);
    setSelectedDay(null);

    const classroom = course.time_slots.find(
      (slot: any) => slot.course_slot_id === parseInt(classroomId),
    );

    if (!classroom) return setScheduleOptions([]);

    const formatted = classroom.schedules.map((schedule: any) => {
      const timeslotLabels = schedule.class_timeslots.map((ts: any) => {
        const start = format12HourTime(ts.start_time);
        const end = format12HourTime(ts.end_time);
        const day = formatDay(ts.day);
        return `${start} – ${end} ${day}`;
      });

      // Format combined string
      const label =
        timeslotLabels.length === 1
          ? timeslotLabels[0]
          : timeslotLabels.slice(0, -1).join(", ") +
            " & " +
            timeslotLabels.slice(-1);

      return {
        course_schedule_id: schedule.course_schedule_id,
        label,
      };
    });

    setScheduleOptions(formatted);
  };

  // Handle day selection
  const handleDayChange = (course_schedule_id: string) => {
    setSelectedDay(course_schedule_id);
  };

  const [selectedBundleIndex, setSelectedBundleIndex] = useState<number>(0);

  const getBundleCourseDetail = async (courseId: number) => {
    startProgress(1);
    try {
      const res = await api.get(
        `${process.env.REACT_APP_API_BASE_URL}/course/branch/${courseId}`,
      );
      setBundleCourseDetail(res.data.data);
      resetBundleSelections();
      setBundleCartOptionOpen(true);
    } catch (err) {
      toast.error(t("server_error"));
    } finally {
      tickProgress();
    }
  };

  // Function to handle adding bundle course to cart
  function handleAddBundleCourseToCart(bundleCourseId: number) {
    let studentIds: number[] = [];
    if (homePageShow === "academy" || homePageShow === "explore") {
      if (!innerSelectedStudent || innerSelectedStudent.length === 0)
        return toast.warn(t("course_view.please_select_student"));
      studentIds = innerSelectedStudent.map((student) => student.id);
    } else {
      if (!selectedStudent || Object.keys(selectedStudent).length == 0)
        return toast.warn(t("course_view.please_select_student"));
      studentIds = [selectedStudent.id];
    }

    // Payment Term validation
    if (
      !selectedBundlePricingPackage ||
      selectedBundleMonths.length % selectedBundlePricingPackage.count !== 0
    ) {
      return toast.warn(t("course_view.please_select_valid_payment_month"));
    }

    // Check if selectedMonths length is a valid multiple of course.period
    if (
      bundleCourseDetail.pricing_method &&
      bundleCourseDetail.pricing_method.name === "Month"
    ) {
      if (selectedBundleMonths.length === 0)
        return toast.warn(t("course_view.please_select_period"));
    }

    // Convert selectedBundleMonths into the desired format
    const formattedMonths = selectedBundleMonths.map((month: Month) => {
      const [monthName, year] = month.name.split(" ");
      const date = new Date(`${monthName} 1, ${year}`);
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
      });
    });

    // Get the selected classroom
    const classroom = bundleCourseDetail.time_slots.find(
      (slot: any) => slot.course_slot_id === parseInt(selectedBundleClassroom!),
    );
    if (!classroom)
      return toast.warn(t("course_view.please_select_classroom_day_timeslot"));

    const timeSlotId = bundleCourseDetail.time_slots
      .flatMap((slot) => slot.schedules)
      .find((schedule) => schedule.course_schedule_id == selectedBundleDay)
      ?.class_timeslots[0]?.time_slot_id;

    let payload: any = {
      student_ids: studentIds,
      type: "course",
      id: bundleCourseId,
      course_branch_id: bundleCourseId,
      payment_term_id: selectedBundlePricingPackage.id,
      time_slot_id: timeSlotId,
      course_slot_id: selectedBundleClassroom,
      course_schedule_id: selectedBundleDay,
    };

    // pricing_method == Month only have selected Month to choose
    if (
      bundleCourseDetail.pricing_method &&
      bundleCourseDetail.pricing_method.name === "Month"
    ) {
      payload["selected_date"] = formattedMonths;
    }

    startProgress(1);
    api
      .post(`${process.env.PUBLIC_URL}/cart/add`, payload)
      .then((res) => {
        toast.success(t("course_view.added_to_cart"));
        setBundleCartOptionOpen(false);
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.errors &&
          err.response.data.errors.message.length > 0
        ) {
          for (let msg in err.response.data.errors.message) {
            toast.error(err.response.data.errors.message[msg]);
          }
        } else {
          toast.error(t("server_error"));
        }
      })
      .finally(() => {
        tickProgress();
      });
  }

  const resetCourseSelections = () => {
    console.log("resetCourseSelections");
    setSelectedClassroom(null);
    setSelectedDay(null);
    setSelectedPricingPackage(null);
    setSelectedMonths([]);
    setIsOpen(false);
  };

  const resetBundleSelections = () => {
    console.log("resetBundleSelections");
    setSelectedBundleClassroom(null);
    setSelectedBundleDay(null);
    setSelectedBundlePricingPackage(null);
    setSelectedBundleMonths([]);
    setIsOpen(false);
  };

  useEffect(() => {
    fetchStudentsRefresh();
  }, []);

  return (
    <>
      <div className="pb-20 px-2">
        <div className="mb-3 grid grid-cols-6">
          <div className="self-center">
            <IoIosArrowBack
              size={24}
              color="#000"
              onClick={() => navigateBack()}
            />
          </div>
          <div className="text-center col-span-4 text-lg font-medium">
            {course.course_name}
          </div>
          <div></div>
        </div>
        <div className="mb-4">
          <Swiper
            pagination={{
              dynamicBullets: true,
            }}
            modules={[Pagination]}
            className="h-96"
          >
            {course.images && course.images.length > 0 ? (
              course.images.map((img: string, index: number) => (
                <SwiperSlide key={index}>
                  <div className="flex justify-center items-center w-full bg-white h-[calc(100%-30px)]">
                    <img
                      src={img}
                      alt={`Slide ${index}`}
                      className="object-cover h-full cursor-pointer"
                      onClick={() => {
                        setPreviewImage(img);
                        setCurrentImageIndex(index);
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <SwiperSlide>
                <div className="flex justify-center items-center w-full bg-white h-[calc(100%-30px)]">
                  <img
                    src="/assets/img/products/product1.png"
                    alt="Default course image"
                    className="object-cover h-full cursor-pointer"
                    onClick={() => {
                      setPreviewImage("/assets/img/products/product1.png");
                      setCurrentImageIndex(0);
                    }}
                  />
                </div>
              </SwiperSlide>
            )}
          </Swiper>
        </div>

        <div className="pt-4 pb-2">
          <div className="mb-4">
            <div className="grid grid-cols-6 gap-1">
              <div className="col-span-4">
                <div className="text-lg font-medium">{course.course_name}</div>
                <div className="text-base font-normal">
                  {course.branch_name || "-"}
                </div>
              </div>
              <div className="col-span-2 text-right text-[22px] font-medium text-theme">
                {getBasePrice()}
              </div>
            </div>
          </div>
        </div>

        {/* Tab-like Navigation */}
        <div className="sticky top-0 z-10 bg-white flex mb-4 justify-around border-b border-gray-200">
          <button
            onClick={() =>
              document
                .getElementById("detail-section")
                ?.scrollIntoView({ behavior: "smooth" })
            }
            className="px-4 py-2 text-lg font-medium border-b-2 border-theme"
          >
            {t("course_view.detail")}
          </button>
          {course.bundle_promotion && course.bundle_promotion.length > 0 && (
            <button
              onClick={() =>
                document
                  .getElementById("bundle-section")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="px-4 py-2 text-lg font-medium"
            >
              {t("course_view.bundle")}
            </button>
          )}
          <button
            onClick={() =>
              document
                .getElementById("item-section")
                ?.scrollIntoView({ behavior: "smooth" })
            }
            className="px-4 py-2 text-lg font-medium"
          >
            {t("course_view.item")}
          </button>
        </div>

        <div id="detail-section" className="scroll-mt-16 pt-2 pb-1">
          {/* Description Section */}
          <div className="mb-4">
            <div className="text-sm break-words overflow-hidden">
              {isExpanded
                ? parse(course.description)
                : getShortenedDescription(course.description)}
            </div>
            <button
              className="text-theme hover:text-theme focus:outline-none mt-2 text-sm underline"
              onClick={toggleExpanded}
            >
              {isExpanded
                ? t("course_view.view_less")
                : t("course_view.view_more")}
            </button>
          </div>

          {/* Academy contact card */}
          <div className="mb-4 rounded-2xl bg-[#176C38] p-4 shadow-[0_4px_8px_rgba(0,0,0,0.18)]">
            <button
              type="button"
              onClick={() =>
                course.branch_id &&
                navigate(`/explore/branch/${course.branch_id}`)
              }
              disabled={!course.branch_id}
              className="flex w-full items-center gap-3 rounded-lg text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white disabled:cursor-default"
              aria-label={`${course.branch_name || "Academy"} branch details`}
            >
              <span className="h-11 w-11 shrink-0 overflow-hidden rounded-full border-2 border-white bg-white">
                <img
                  src={
                    course.branch_images || "/assets/img/academy-default.png"
                  }
                  alt=""
                  className="h-full w-full object-cover"
                />
              </span>
              <span className="min-w-0 flex-1 truncate text-lg font-semibold text-white">
                {course.branch_name || "-"}
              </span>
              <IoIosArrowForward
                aria-hidden="true"
                size={24}
                className="shrink-0 text-white"
              />
            </button>

            <div className="mt-4 grid grid-cols-2 gap-3">
              {course.website_link && course.website_link !== "-" ? (
                <a
                  href={course.website_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-12 min-w-0 items-center justify-center gap-2 rounded-full bg-black px-3 text-sm font-semibold text-white transition-opacity hover:opacity-85 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                >
                  <FaGlobe aria-hidden="true" size={18} />
                  <span className="truncate">{t("course_view.website")}</span>
                </a>
              ) : (
                <span
                  aria-disabled="true"
                  className="flex h-12 min-w-0 items-center justify-center gap-2 rounded-full bg-black px-3 text-sm font-semibold text-white opacity-45"
                >
                  <FaGlobe aria-hidden="true" size={18} />
                  <span className="truncate">{t("course_view.website")}</span>
                </span>
              )}

              {course.whatapps && course.whatapps !== "-" ? (
                <a
                  href={`https://api.whatsapp.com/send?phone=${
                    "60" + course.whatapps.replace(/[^\d]/g, "")
                  }&text=${encodeURIComponent(
                    `Hello I click the link on MYKOKU Parent, I am interested in ${course.course_name} (${course.course_id}) at ${course.branch_name}`,
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-12 min-w-0 items-center justify-center gap-2 rounded-full bg-[#10D6B3] px-3 text-sm font-semibold text-white transition-opacity hover:opacity-85 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                >
                  <FaWhatsapp aria-hidden="true" size={20} />
                  <span className="truncate">{t("explore.whatsapp")}</span>
                </a>
              ) : (
                <span
                  aria-disabled="true"
                  className="flex h-12 min-w-0 items-center justify-center gap-2 rounded-full bg-[#10D6B3] px-3 text-sm font-semibold text-white opacity-45"
                >
                  <FaWhatsapp aria-hidden="true" size={20} />
                  <span className="truncate">{t("explore.whatsapp")}</span>
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          {/* <button onClick={() => { toast.success("Added to Favourite") }} className="w-1/6 flex gap-3 text-white justify-center items-center font-normal h-12 cursor-pointer rounded-full  hover:bg-gray-200" >
                    <FaHeart size={24} color='#FF0000'/>
                </button> */}
          <button
            onClick={() => {
              resetCourseSelections();
              setCartOptionOpen(true);
            }}
            className="bg-theme w-5/6 flex gap-3 text-white justify-center text-center my-3 h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400"
          >
            <FaRegClock size={18} />
            {t("course_view.check_timeslot")}
          </button>
        </div>

        {course.bundle_promotion && course.bundle_promotion.length > 0 && (
          <div
            id="bundle-section"
            className="scroll-mt-16 mt-4 py-3 border-t-2 border-gray-300"
          >
            <div className="">
              {/* Bundle Selection Tabs */}
              <div className="flex flex-wrap gap-2 my-3">
                {course.bundle_promotion.map((bundle: any, index: number) => (
                  <button
                    key={bundle.bundle_id}
                    className={`px-2 py-1 rounded-full text-sm font-medium transition-colors ${
                      selectedBundleIndex === index
                        ? "bg-orange-500 text-white"
                        : "border border-orange-500 text-orange-500 hover:bg-orange-50"
                    }`}
                    onClick={() => setSelectedBundleIndex(index)}
                  >
                    {bundle.bundle_name}
                  </button>
                ))}
              </div>

              {/* Current Bundle Details */}
              {course.bundle_promotion[selectedBundleIndex] && (
                <>
                  <h2 className="text-xl font-semibold mb-3">
                    {course.bundle_promotion[selectedBundleIndex].bundle_name}
                  </h2>

                  {/* Bundle Options */}
                  <div className="flex flex-wrap gap-2 mb-6">
                    {course.bundle_promotion[selectedBundleIndex]
                      .bundle_packages &&
                      course.bundle_promotion[
                        selectedBundleIndex
                      ].bundle_packages.map((pkg: any) => (
                        <div
                          key={pkg.id}
                          className="flex items-center border border-orange-500 rounded-full px-2 py-1"
                        >
                          <IoBookmarks className="text-orange-500 text-xs mr-1" />
                          <span className="text-orange-500 text-sm font-medium">
                            {pkg.count} {t("promotion.course")} - RM
                            {pkg.discount_value}
                          </span>
                        </div>
                      ))}
                  </div>

                  {/* Bundle Courses Grid - Horizontal Swipe */}
                  <div className="relative">
                    <div className="overflow-x-auto custom-scrollbar">
                      <div
                        className="flex gap-4 pb-4"
                        style={{ width: "max-content" }}
                      >
                        {course.bundle_promotion[selectedBundleIndex].courses &&
                          course.bundle_promotion[
                            selectedBundleIndex
                          ].courses.map((bundleCourse: any) => (
                            <BundleCard
                              key={bundleCourse.course_branch_id}
                              course={{
                                course_branch_id: bundleCourse.course_branch_id,
                                course_name: bundleCourse.course_name,
                                course_images: bundleCourse.course_images,
                                price: 0,
                              }}
                              onAddToCart={getBundleCourseDetail}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <div
          id="item-section"
          className="flex items-center justify-center my-6"
        >
          <div className="flex-grow border-t border-gray-300"></div>
          <span className="mx-4 text-gray-500 text-base font-medium">
            {t("course_view.material_you_may_need")}
          </span>
          <div className="flex-grow border-t border-gray-300"></div>
        </div>

        <div className="grid grid-cols-2 gap-2 mt-4">
          {course.items &&
            course.items.map((item: any, index: number) => (
              <div
                className="p-2 px-2.5 rounded-xl mb-4 shadow-course-card"
                key={index}
              >
                <div
                  onClick={() =>
                    navigate(`/item/${item.id}?course_branch_id=${id}`)
                  }
                  className="text-base font-medium mb-2 truncate"
                >
                  {item.name}
                </div>
                <Link
                  to={`/item/${item.id}?course_branch_id=${id}`}
                  className="w-full"
                >
                  <div className="py-2 text-center">
                    {item.images && item.images.length > 0 ? (
                      <img
                        style={{ height: "10rem" }}
                        className="rounded-2xl inline-block"
                        alt=""
                        src={item.images[0]}
                      />
                    ) : (
                      <img
                        style={{ height: "10rem" }}
                        className="rounded-2xl inline-block"
                        alt=""
                        src="/assets/img/products/product1.png"
                      />
                    )}
                  </div>
                </Link>
                <Link
                  to={`/item/${item.id}?course_branch_id=${id}`}
                  className="flex justify-between"
                >
                  <div className="text-base font-medium">RM {item.price}</div>
                  <div className="text-sm font-normal text-gray-400 self-end">
                    {t("course_view.stock")}: {item.stock}
                  </div>
                </Link>
                <div className="flex justify-center">
                  <div
                    onClick={() => {
                      openCartItemOption(item.id);
                    }}
                    className="bg-theme w-full flex gap-2 text-white justify-center items-center text-center mt-3 py-2 px-1 rounded-full cursor-pointer hover:bg-gray-400"
                  >
                    <FiPlusCircle size={18} />
                    <div>{t("course_view.add_to_cart")}</div>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {cartOptionOpen && (
          <div
            className="fixed inset-0 z-10 bg-black bg-opacity-50 flex justify-center items-end"
            onClick={() => setCartOptionOpen(false)}
          >
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ stiffness: 100 }}
              className="w-full max-w-[648px] bg-white shadow-2xl rounded-t-3xl px-4 pt-4 pb-20 max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="grid grid-cols-6 gap-1 pb-3 mb-3 border-b-2 border-gray-300">
                <div className="col-span-4">
                  <div className="text-lg font-medium">
                    {course.course_name}
                  </div>
                  <div className="text-md mt-1 font-normal">
                    {course.branch_name || "-"}
                  </div>
                </div>
                <div className="text-lg font-medium col-span-2 text-end">
                  RM {getCalculatedPrice()}
                </div>
              </div>

              {/* Classroom Selection */}
              <div className="mb-4">
                <div className="mb-1 text-base font-medium">
                  ✏️ {t("course_view.classroom")}{" "}
                  <span className="italic text-gray-400 font-light">
                    {t("course_view.choose_1_only")}
                  </span>
                </div>
                <div className="grid grid-cols-1 gap-2">
                  {course.time_slots &&
                    course.time_slots.map((classroom: any) => (
                      <div
                        key={classroom.course_slot_id}
                        className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${
                          selectedClassroom === classroom.course_slot_id
                            ? "bg-theme text-white"
                            : "bg-gray-100 text-black"
                        } transition duration-300`}
                        onClick={() =>
                          handleClassroomChange(classroom.course_slot_id)
                        }
                      >
                        {selectedClassroom === classroom.course_slot_id ? (
                          <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                            <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                          </div>
                        ) : (
                          <div className="w-5 h-5 border-2 border-black rounded-full flex items-center justify-center">
                            <div className="w-2.5 h-2.5 rounded-full"></div>
                          </div>
                        )}
                        <div className="truncate">{classroom.name}</div>
                      </div>
                    ))}
                </div>
              </div>

              {/* Day Selection */}
              <div className="mb-4">
                <div className="mb-1 text-base font-medium">
                  📅 {t("course_view.class_day")}{" "}
                  <span className="italic text-gray-400 font-light">
                    {t("course_view.choose_1_only")}
                  </span>
                </div>
                <select
                  className="text-lg font-light rounded-md px-2 py-1 bg-white border border-gray-300 flex items-center w-full truncate"
                  value={selectedDay || ""}
                  onChange={(e) => handleDayChange(e.target.value)}
                  disabled={!selectedClassroom}
                >
                  <option value="" disabled>
                    {t("course_view.select_day")}
                  </option>
                  {scheduleOptions.map((opt) => (
                    <option
                      key={opt.course_schedule_id}
                      value={opt.course_schedule_id}
                    >
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>

              {course.pricing_method &&
                course.pricing_method.name === "Month" && (
                  <>
                    <div className="pt-2 border-gray-300 border-t-2 mb-3">
                      <div className="mb-1 text-base font-medium">
                        {t("course_view.payment_term")}{" "}
                        <span className="italic text-gray-400 font-light">
                          {t("course_view.choose_1_only")}
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2 mt-2">
                        {course.pricing_packages &&
                          course.pricing_packages.map((pricingPackage: any) => (
                            <div
                              key={pricingPackage.id}
                              className={`flex items-center gap-2 px-2 py-2 rounded-lg border ${
                                selectedPricingPackage?.id === pricingPackage.id
                                  ? " bg-theme  text-white "
                                  : "bg-gray-100 text-black"
                              } transition duration-300`}
                              onClick={() =>
                                setSelectedPricingPackage(pricingPackage)
                              }
                            >
                              {selectedPricingPackage?.id ==
                              pricingPackage.id ? (
                                <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                  <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                </div>
                              ) : (
                                <div className="w-5 h-5 border-2 border-black rounded-full flex items-center justify-center">
                                  <div className="w-2.5 h-2.5 rounded-full"></div>
                                </div>
                              )}
                              <div className="line-clamp-2">
                                {pricingPackage.count} {t("course_view.month")}{" "}
                                RM {pricingPackage.fee}
                                {pricingPackage.description ? ` (${pricingPackage.description})` : ''}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>

                    <div className="pb-2 pt-2 border-t-2 border-gray-300">
                      <div className="mb-1 text-base font-medium">
                        {t("course_view.paying_for")}
                      </div>
                      <div className="mt-2 border border-gray-300 rounded-md bg-white">
                        <button
                          className="text-lg font-light px-2 py-1 w-full flex items-center truncate"
                          onClick={toggleDropdown}
                        >
                          <span>{getSelectedRangeLabel()}</span>
                        </button>
                        {isOpen && (
                          <div className="mt-1 border-t border-gray-200 w-full max-h-52 overflow-y-auto z-10">
                            {months.map((month) => (
                              <div
                                key={month.id}
                                className={`flex items-center px-4 py-1 ${
                                  month.disabled
                                    ? "opacity-50 cursor-not-allowed line-through"
                                    : "hover:bg-gray-100 cursor-pointer"
                                }`}
                                onClick={() => {
                                  if (!month.disabled) {
                                    handleSelectMonth(month);
                                  }
                                }}
                              >
                                <input
                                  type="checkbox"
                                  className="mr-2"
                                  checked={isChecked(month)}
                                  readOnly
                                  disabled={month.disabled}
                                />
                                <span className="text-lg">
                                  {month.name}{" "}
                                  {month.disabled &&
                                    `(${t("course_view.waived")})`}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

              {course.pricing_method &&
                (course.pricing_method.name === "Attandance" ||
                  course.pricing_method.name === "Attandance-No replace") && (
                  <>
                    <div className="pb-2 pt-2 border-gray-300 border-t-2 mb-2">
                      <div className="mb-1 text-base font-medium">
                        {t("course_view.payment_term")}{" "}
                        <span className="italic text-gray-400 font-light">
                          {t("course_view.choose_1_only")}
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2 mt-2">
                        {course.pricing_packages &&
                          course.pricing_packages.map((pricingPackage: any) => (
                            <div
                              key={pricingPackage.id}
                              className={`flex items-center gap-2 px-2 py-2 rounded-lg border ${
                                selectedPricingPackage?.id === pricingPackage.id
                                  ? " bg-theme  text-white "
                                  : "bg-gray-100 text-black"
                              } transition duration-300`}
                              onClick={() =>
                                setSelectedPricingPackage(pricingPackage)
                              }
                            >
                              {selectedPricingPackage?.id ==
                              pricingPackage.id ? (
                                <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                  <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                </div>
                              ) : (
                                <div className="w-5 h-5 border-2 border-black rounded-full flex items-center justify-center">
                                  <div className="w-2.5 h-2.5 rounded-full"></div>
                                </div>
                              )}
                              <div className="line-clamp-2">
                                {pricingPackage.count} attd RM{" "}
                                {pricingPackage.fee}
                                {pricingPackage.description ? ` (${pricingPackage.description})` : ''}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </>
                )}

              {/* Coming from Academy where no students selected */}
              {(homePageShow === "academy" || homePageShow === "explore") && (
                <div className="pb-2 pt-2 border-gray-300 border-t-2 ">
                  <div className="mb-1 text-base font-medium">
                    {t("course_view.choose_student")}
                  </div>
                  <div className="grid grid-cols-2 gap-2 mt-2">
                    {students &&
                      students.map((student: any) => {
                        const isSelected = innerSelectedStudent.some(
                          (s) => s.id === student.id,
                        );
                        return (
                          <div
                            key={student.id}
                            className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${
                              isSelected
                                ? " bg-theme  text-white "
                                : "bg-gray-100 text-black"
                            } transition duration-300`}
                            onClick={() => toggleInnerSelectedStudent(student)}
                          >
                            {isSelected ? (
                              <FaCheck className="w-5 h-5" />
                            ) : (
                              <div className="w-5 h-5 border border-black rounded-md"></div>
                            )}
                            <div className="truncate">{student.name}</div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}

              {/* Coming from School where student selected */}
              {homePageShow === "school" && (
                <div className="pb-2 pt-2 border-gray-300 border-t-2 ">
                  <div className="mb-1 text-base font-medium">
                    {t("course_view.choose_student")}
                  </div>

                  <div className="grid grid-cols-2 gap-2 mt-2">
                    {students &&
                      students.map((student: any) => (
                        <div
                          key={student.id}
                          className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${
                            selectedStudent?.id == student.id
                              ? " bg-theme  text-white "
                              : "bg-gray-100 text-black"
                          } transition duration-300`}
                        >
                          {selectedStudent?.id == student.id ? (
                            <>
                              <div className="flex-shrink-0 w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                              </div>
                              <div className="pl-1 truncate">
                                {student.name}
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flex-shrink-0 w-5 h-5 border-2 border-gray-400 rounded-full flex items-center justify-center">
                                <div className="w-2.5 h-2.5 rounded-full"></div>
                              </div>
                              <div className="pl-1 truncate text-gray-400">
                                {student.name}
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              )}

              {selectedClassroom &&
              selectedClassroom &&
              course.time_slots
                .find(
                  (slot: any) =>
                    slot.course_slot_id === parseInt(selectedClassroom),
                )
                .schedules.find(
                  (schedule: any) => schedule.course_schedule_id == selectedDay,
                )?.pre_enroll ? (
                <button
                  onClick={() => handlePreEnroll()}
                  className="bg-[#023f81] w-full flex gap-3 text-white justify-center text-center h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400l mt-3"
                >
                  <FaClipboardCheck size={18} />
                  {t("course_view.pre_enrol")}
                </button>
              ) : (
                <button
                  onClick={() => handleAddToCart()}
                  className="bg-theme w-full flex gap-3 text-white justify-center text-center h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400l mt-3"
                >
                  <FaShoppingCart size={18} />
                  {t("course_view.add_to_cart")}
                </button>
              )}
            </motion.div>
          </div>
        )}

        {bundleCartOptionOpen && bundleCourseDetail && (
          <div
            className="fixed inset-0 z-10 bg-black bg-opacity-50 flex justify-center items-end"
            onClick={() => setBundleCartOptionOpen(false)}
          >
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ stiffness: 100 }}
              className="w-full max-w-[648px] bg-white shadow-2xl rounded-t-3xl px-4 pt-4 pb-20 max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="grid grid-cols-6 gap-1 mb-2">
                <div className="col-span-4">
                  <div className="text-lg font-medium">
                    {bundleCourseDetail.course_name}
                  </div>
                  <div className="text-md mt-1 font-normal">
                    {bundleCourseDetail.branch_name || "-"}
                  </div>
                </div>
                <div className="text-lg font-medium col-span-2 text-end">
                  RM{" "}
                  {bundleCourseDetail.pricing_packages &&
                  bundleCourseDetail.pricing_packages.length > 0
                    ? bundleCourseDetail.pricing_packages[0].fee
                    : "-"}
                </div>
              </div>

              {/* Timeslot selection for bundle course */}
              <div className="mb-4">
                <div className="mb-1 text-base font-medium">
                  ✏️ {t("course_view.classroom")}{" "}
                  <span className="italic text-gray-400 font-light">
                    {t("course_view.choose_1_only")}
                  </span>
                </div>
                <div className="grid grid-cols-1 gap-2">
                  {bundleCourseDetail.time_slots &&
                    bundleCourseDetail.time_slots.map((classroom: any) => (
                      <div
                        key={classroom.course_slot_id}
                        className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${
                          selectedBundleClassroom === classroom.course_slot_id
                            ? "bg-theme text-white"
                            : "bg-gray-100 text-black"
                        } transition duration-300`}
                        onClick={() =>
                          setSelectedBundleClassroom(classroom.course_slot_id)
                        }
                      >
                        {selectedBundleClassroom ===
                        classroom.course_slot_id ? (
                          <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                            <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                          </div>
                        ) : (
                          <div className="w-5 h-5 border-2 border-black rounded-full flex items-center justify-center">
                            <div className="w-2.5 h-2.5 rounded-full"></div>
                          </div>
                        )}
                        <div className="truncate">{classroom.name}</div>
                      </div>
                    ))}
                </div>
              </div>

              <div className="mb-4">
                <div className="mb-1 text-base font-medium">
                  📅 {t("course_view.class_day")}{" "}
                  <span className="italic text-gray-400 font-light">
                    {t("course_view.choose_1_only")}
                  </span>
                </div>
                <select
                  className="text-lg font-light rounded-md px-2 py-1 bg-white border border-gray-300 flex items-center w-full truncate"
                  value={selectedBundleDay || ""}
                  onChange={(e) => setSelectedBundleDay(e.target.value)}
                  disabled={!selectedBundleClassroom}
                >
                  <option value="" disabled>
                    {t("course_view.select_day")}
                  </option>
                  {selectedBundleClassroom &&
                    bundleCourseDetail.time_slots &&
                    bundleCourseDetail.time_slots
                      .find(
                        (slot: any) =>
                          slot.course_slot_id === selectedBundleClassroom,
                      )
                      ?.schedules.map((opt: any) => {
                        const timeslotLabels = opt.class_timeslots.map(
                          (ts: any) => {
                            const start = format12HourTime(ts.start_time);
                            const end = format12HourTime(ts.end_time);
                            const day = formatDay(ts.day);
                            return `${start} – ${end} ${day}`;
                          },
                        );
                        const label =
                          timeslotLabels.length === 1
                            ? timeslotLabels[0]
                            : timeslotLabels.slice(0, -1).join(", ") +
                              " & " +
                              timeslotLabels.slice(-1);
                        return (
                          <option
                            key={opt.course_schedule_id}
                            value={opt.course_schedule_id}
                          >
                            {label}
                          </option>
                        );
                      })}
                </select>
              </div>

              {bundleCourseDetail.pricing_method &&
                bundleCourseDetail.pricing_method.name === "Month" && (
                  <>
                    <div className="pb-2 pt-2 border-gray-300 border-t-2 mb-3">
                      <div className="mb-1 text-base font-medium">
                        {t("course_view.payment_term")}{" "}
                        <span className="italic text-gray-400 font-light">
                          {t("course_view.choose_1_only")}
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2 mt-2">
                        {bundleCourseDetail.pricing_packages &&
                          bundleCourseDetail.pricing_packages.map(
                            (pricingPackage: any) => (
                              <div
                                key={pricingPackage.id}
                                className={`flex items-center gap-2 px-2 py-2 rounded-lg border ${
                                  selectedBundlePricingPackage?.id ===
                                  pricingPackage.id
                                    ? " bg-theme  text-white "
                                    : "bg-gray-100 text-black"
                                } transition duration-300`}
                                onClick={() =>
                                  setSelectedBundlePricingPackage(
                                    pricingPackage,
                                  )
                                }
                              >
                                {selectedBundlePricingPackage?.id ==
                                pricingPackage.id ? (
                                  <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                    <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                  </div>
                                ) : (
                                  <div className="w-5 h-5 border-2 border-black rounded-full flex items-center justify-center">
                                    <div className="w-2.5 h-2.5 rounded-full"></div>
                                  </div>
                                )}
                                <div className="line-clamp-2">
                                  {pricingPackage.count}{" "}
                                  {t("course_view.month")} RM{" "}
                                  {pricingPackage.fee}
                                  {pricingPackage.description ? ` (${pricingPackage.description})` : ''}
                                </div>
                              </div>
                            ),
                          )}
                      </div>
                    </div>

                    <div className="pb-2 pt-2 border-t-2 border-gray-300">
                      <div className="mb-1 text-base font-medium">
                        {t("course_view.paying_for")}
                      </div>
                      <div className="mt-2 border border-gray-300 rounded-md bg-white">
                        <button
                          className="text-lg font-light px-2 py-1 w-full flex items-center truncate"
                          onClick={toggleDropdown}
                        >
                          <span>{getSelectedRangeLabelBundle()}</span>
                        </button>
                        {isOpen && (
                          <div className="mt-1 border-t border-gray-200 w-full max-h-52 overflow-y-auto z-10">
                            {months.map((month) => (
                              <div
                                key={month.id}
                                className={`flex items-center px-4 py-1 ${
                                  month.disabled
                                    ? "opacity-50 cursor-not-allowed line-through"
                                    : "hover:bg-gray-100 cursor-pointer"
                                }`}
                                onClick={() => {
                                  if (!month.disabled) {
                                    handleBundleSelectMonth(month);
                                  }
                                }}
                              >
                                <input
                                  type="checkbox"
                                  className="mr-2"
                                  checked={isCheckedBundle(month)}
                                  readOnly
                                  disabled={month.disabled}
                                />
                                <span className="text-lg">
                                  {month.name}{" "}
                                  {month.disabled &&
                                    `(${t("course_view.waived")})`}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

              {bundleCourseDetail.pricing_method &&
                (bundleCourseDetail.pricing_method.name === "Attandance" ||
                  bundleCourseDetail.pricing_method.name ===
                    "Attandance-No replace") && (
                  <>
                    <div className="pb-2 pt-2 border-gray-300 border-t-2 mb-2">
                      <div className="mb-1 text-base font-medium">
                        {t("course_view.payment_term")}{" "}
                        <span className="italic text-gray-400 font-light">
                          {t("course_view.choose_1_only")}
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2 mt-2">
                        {bundleCourseDetail.pricing_packages &&
                          bundleCourseDetail.pricing_packages.map(
                            (pricingPackage: any) => (
                              <div
                                key={pricingPackage.id}
                                className={`flex items-center gap-2 px-2 py-2 rounded-lg border ${
                                  selectedBundlePricingPackage?.id ===
                                  pricingPackage.id
                                    ? " bg-theme  text-white "
                                    : "bg-gray-100 text-black"
                                } transition duration-300`}
                                onClick={() =>
                                  setSelectedBundlePricingPackage(
                                    pricingPackage,
                                  )
                                }
                              >
                                {selectedBundlePricingPackage?.id ==
                                pricingPackage.id ? (
                                  <div className="w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                    <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                  </div>
                                ) : (
                                  <div className="w-5 h-5 border-2 border-black rounded-full flex items-center justify-center">
                                    <div className="w-2.5 h-2.5 rounded-full"></div>
                                  </div>
                                )}
                                <div className="line-clamp-2">
                                  {pricingPackage.count} attd RM{" "}
                                  {pricingPackage.fee}
                                  {pricingPackage.description ? ` (${pricingPackage.description})` : ''}
                                </div>
                              </div>
                            ),
                          )}
                      </div>
                    </div>
                  </>
                )}

              {/* Student selection (academy/school) */}
              {(homePageShow === "academy" || homePageShow === "explore") && (
                <div className="pb-2 pt-2 border-gray-300 border-t-2 ">
                  <div className="mb-1 text-base font-medium">
                    {t("course_view.choose_student")}
                  </div>
                  <div className="grid grid-cols-2 gap-2 mt-2">
                    {students &&
                      students.map((student: any) => {
                        const isSelected = innerSelectedStudent.some(
                          (s) => s.id === student.id,
                        );
                        return (
                          <div
                            key={student.id}
                            className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${
                              isSelected
                                ? " bg-theme  text-white "
                                : "bg-gray-100 text-black"
                            } transition duration-300`}
                            onClick={() => toggleInnerSelectedStudent(student)}
                          >
                            {isSelected ? (
                              <FaCheck className="w-5 h-5" />
                            ) : (
                              <div className="w-5 h-5 border border-black rounded-md"></div>
                            )}
                            <div className="truncate">{student.name}</div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}

              {homePageShow === "school" && (
                <div className="pb-2 pt-2 border-gray-300 border-t-2 ">
                  <div className="mb-1 text-base font-medium">
                    {t("course_view.choose_student")}
                  </div>
                  <div className="grid grid-cols-2 gap-2 mt-2">
                    {students &&
                      students.map((student: any) => (
                        <div
                          key={student.id}
                          className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${
                            selectedStudent?.id == student.id
                              ? " bg-theme  text-white "
                              : "bg-gray-100 text-black"
                          } transition duration-300`}
                        >
                          {selectedStudent?.id == student.id ? (
                            <>
                              <div className="flex-shrink-0 w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                              </div>
                              <div className="pl-1 truncate">
                                {student.name}
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flex-shrink-0 w-5 h-5 border-2 border-gray-400 rounded-full flex items-center justify-center">
                                <div className="w-2.5 h-2.5 rounded-full"></div>
                              </div>
                              <div className="pl-1 truncate text-gray-400">
                                {student.name}
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              )}

              <button
                onClick={() => {
                  handleAddBundleCourseToCart(
                    bundleCourseDetail.course_branch_id,
                  );
                }}
                className="bg-theme w-full flex gap-3 text-white justify-center text-center h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400l mt-3"
              >
                <FaShoppingCart size={18} />
                {t("course_view.add_bundle_to_cart")}
              </button>
            </motion.div>
          </div>
        )}

        {cartItemOptionOpen && (
          <div
            className="fixed inset-0 z-10 bg-black bg-opacity-50 flex justify-center items-end"
            onClick={() => setCartItemOptionOpen(false)}
          >
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ stiffness: 100 }}
              className="w-full max-w-[648px] bg-white shadow-2xl rounded-t-3xl px-4 pt-4 pb-20"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Coming from Academy where no students selected */}
              {(homePageShow === "academy" || homePageShow === "explore") && (
                <div className="pb-2">
                  <div className="mb-1 text-base font-medium">
                    {t("course_view.choose_student")}{" "}
                    <span className="text-gray-500 italic font-normal">
                      {t("course_view.choose_1_only")}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-2 mt-2">
                    {students &&
                      students.map((student: any) => {
                        const isSelected = innerSelectedStudent.some(
                          (s) => s.id === student.id,
                        );
                        return (
                          <div
                            key={student.id}
                            className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${
                              isSelected
                                ? " bg-theme  text-white "
                                : "bg-gray-100 text-black"
                            } transition duration-300`}
                            onClick={() => toggleInnerSelectedStudent(student)}
                          >
                            {isSelected ? (
                              <FaCheck className="w-5 h-5" />
                            ) : (
                              <div className="w-5 h-5 border border-black rounded-md"></div>
                            )}
                            <div className="truncate">{student.name}</div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}

              {/* Coming from School where student selected */}
              {homePageShow === "school" && (
                <div className="pb-2">
                  <div className="mb-1 text-base font-medium">
                    {t("course_view.choose_student")}
                  </div>

                  <div className="grid grid-cols-2 gap-2 mt-2">
                    {students &&
                      students.map((student: any) => (
                        <div
                          key={student.id}
                          className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${
                            selectedStudent?.id == student.id
                              ? " bg-theme  text-white "
                              : "bg-gray-100 text-black"
                          } transition duration-300`}
                        >
                          {selectedStudent?.id == student.id ? (
                            <>
                              <div className="flex-shrink-0 w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                              </div>
                              <div className="pl-1 truncate">
                                {student.name}
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flex-shrink-0 w-5 h-5 border-2 border-gray-400 rounded-full flex items-center justify-center">
                                <div className="w-2.5 h-2.5 rounded-full"></div>
                              </div>
                              <div className="pl-1 truncate text-gray-400">
                                {student.name}
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              )}

              <button
                onClick={() => handleAddToCartItem(selectedItemId)}
                className="bg-theme w-full flex gap-3 text-white justify-center text-center h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400l mt-3"
              >
                <FaShoppingCart size={18} />
                {t("course_view.add_to_cart")}
              </button>
            </motion.div>
          </div>
        )}

        {/* Image Preview Modal with Slider */}
        {previewImage !== null && (
          <div
            className="fixed inset-0 bg-gray-700 bg-opacity-100 place-content-center z-[1100]"
            onClick={() => setPreviewImage(null)}
          >
            <div
              className="relative max-w-full max-h-full p-4"
              onClick={(e) => e.stopPropagation()}
              style={{
                maxWidth: "640px",
                marginLeft: "auto",
                marginRight: "auto",
                paddingLeft: "1rem",
                paddingRight: "1rem",
              }}
            >
              {/* Close button */}
              <button
                onClick={() => {
                  setPreviewImage(null);
                }}
                className="absolute top-2 left-2 bg-white bg-opacity-50 text-black rounded-full p-1.5 shadow-md hover:bg-opacity-100 z-10"
                aria-label="Close"
              >
                <FiX size={18} />
              </button>

              <div className="w-full h-[60vh] max-h-96">
                <Swiper
                  initialSlide={currentImageIndex}
                  pagination={{
                    dynamicBullets: true,
                  }}
                  modules={[Pagination]}
                  className="h-full"
                  onSlideChange={(swiper) => {
                    // Only update the index, don't update previewImage to avoid conflicts
                    setCurrentImageIndex(swiper.realIndex);
                  }}
                >
                  {course.images && course.images.length > 0 ? (
                    course.images.map((img: string, index: number) => (
                      <SwiperSlide key={index}>
                        <div className="flex justify-center items-center h-full">
                          <img
                            src={img}
                            alt={`Preview ${index}`}
                            className="h-full object-contain rounded-md"
                          />
                        </div>
                      </SwiperSlide>
                    ))
                  ) : (
                    <SwiperSlide>
                      <div className="flex justify-center items-center h-full">
                        <img
                          src="/assets/img/products/product1.png"
                          alt="Default preview"
                          className="h-full object-contain rounded-md"
                        />
                      </div>
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>

              <button
                onClick={async () => {
                  try {
                    const response = await fetch(previewImage, {
                      mode: "cors",
                    });
                    const blob = await response.blob();
                    const blobUrl = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = "attendance-image.jpg";
                    document.body.appendChild(link);
                    link.click();
                    if (link && link.parentNode) {
                      link.parentNode.removeChild(link);
                    }

                    window.URL.revokeObjectURL(blobUrl);
                  } catch (err) {
                    toast.error("Download image failed");
                  }
                }}
                className="absolute -bottom-10 right-4 bg-theme text-white px-3 py-1.5 text-sm rounded-full shadow-lg"
              >
                {t("attendance.download_image")}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CourseView;
